import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Btn, Field, Input, Textarea, Toggle, Modal, Confirm, Empty } from "@/pages/admin/managers/ui";
import { Plus, Pencil, Trash2 } from "lucide-react";

export default function FaqManager() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [confirmId, setConfirmId] = useState(null);

  const load = async () => setItems((await api.get("/admin/faqs")).data);
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!modal.question?.trim() || !modal.answer?.trim()) return toast.error("Pregunta y respuesta son obligatorias.");
    try {
      const body = { question: modal.question, answer: modal.answer, is_visible: modal.is_visible !== false };
      if (modal.id) await api.put(`/admin/faqs/${modal.id}`, body);
      else await api.post("/admin/faqs", body);
      toast.success("Pregunta guardada."); setModal(null); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async () => { await api.delete(`/admin/faqs/${confirmId}`); toast.success("Pregunta eliminada."); setConfirmId(null); load(); };

  return (
    <div>
      <div className="flex justify-end mb-6">
        <Btn data-testid="add-faq-btn" onClick={() => setModal({ is_visible: true })}><Plus size={16} className="inline mr-1" /> Nueva pregunta</Btn>
      </div>
      {items.length === 0 ? <Empty>No hay preguntas frecuentes.</Empty> : (
        <div className="space-y-3">
          {items.map((f) => (
            <div key={f.id} data-testid={`faq-row-${f.id}`} className="bg-[#18181B] border border-[#27272A] rounded-lg p-5 flex justify-between gap-4">
              <div>
                <p className="text-white font-medium">{f.question} {!f.is_visible && <span className="text-xs text-[#8C8375]">(oculta)</span>}</p>
                <p className="text-sm text-[#A1A1AA] mt-1">{f.answer}</p>
              </div>
              <div className="flex gap-2 shrink-0">
                <button data-testid={`faq-edit-${f.id}`} onClick={() => setModal(f)} className="text-[#A1A1AA] hover:text-[#C5A059]"><Pencil size={16} /></button>
                <button data-testid={`faq-delete-${f.id}`} onClick={() => setConfirmId(f.id)} className="text-[#A1A1AA] hover:text-red-400"><Trash2 size={16} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
      <Modal open={!!modal} onClose={() => setModal(null)} title={modal?.id ? "Editar pregunta" : "Nueva pregunta"} testid="faq-modal">
        {modal && (
          <>
            <Field label="Pregunta"><Input data-testid="faq-question-input" value={modal.question || ""} onChange={(e) => setModal({ ...modal, question: e.target.value })} /></Field>
            <Field label="Respuesta"><Textarea rows={3} value={modal.answer || ""} onChange={(e) => setModal({ ...modal, answer: e.target.value })} /></Field>
            <Toggle checked={modal.is_visible !== false} onChange={(v) => setModal({ ...modal, is_visible: v })} label="Visible en el sitio" />
            <div className="flex justify-end gap-3 pt-2">
              <Btn variant="ghost" onClick={() => setModal(null)}>Cancelar</Btn>
              <Btn data-testid="faq-save-btn" onClick={save}>Guardar</Btn>
            </div>
          </>
        )}
      </Modal>
      <Confirm open={!!confirmId} onClose={() => setConfirmId(null)} onConfirm={del} message="¿Eliminar esta pregunta?" />
    </div>
  );
}
